import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import camelCase from "lodash/camelCase";

import { hydrate } from "@/lib";
import type { Feature } from "@/types";
import { fetchFeatures } from "./thunk";

export interface FeaturesState {
  features: { [key: string]: Partial<Feature> };
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: FeaturesState = {
  features: {},
  error: null,
  status: "idle"
};

export const featuresSlice = createSlice({
  name: "features",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => ({
        ...state,
        ...action.payload[featuresSlice.name]
      }))
      .addCase(fetchFeatures.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchFeatures.fulfilled, (state, action) => {
        state.status = "idle";
        action.payload.forEach((feature: Feature) => {
          state.features[camelCase(feature.id)] = feature;
        });
      })
      .addCase(fetchFeatures.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
